import React, { useState, useEffect } from 'react';
import {useForm} from "react-hook-form";
import { useAuthToken, useRequestUrl } from "../context/contextHooks";
import API from '../http/API';
import { currentDatetimeIso } from "../config/dateUtils";
import { useSxStyles as classes } from "../styles/sxStyles";
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Grid2 from '@mui/material/Grid2';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

const EnterCall = (props) => {
    const currentUser = props.currentUser;
    const setLogEntry = props.setLogEntry;
    const {
        register,
        handleSubmit
    } = useForm();
    const [requestUrl,] = useRequestUrl();
    const [authToken,] = useAuthToken();
    const [errors, setErrors] = useState(null);
    const [loading, setLoading] = useState(false);
    const [actionResponse, setActionResponse] = useState(null);
    const [entry, setEntry] = useState(null);

    const saveEntry = (form) => {
        if (!form.callerFirstName || !form.callerLastName) {
            setErrors('A first and last name are required');
        } else if (!loading) {
            setErrors(null);
            setActionResponse(null);
            setLoading(true);
            const url = `${requestUrl}/saveNewLogEntry`;
            const data = {...form, currentUser: currentUser, callTimeStr: currentDatetimeIso()};
            setEntry(data);
            API.postRetrieve(url, JSON.stringify(data), 'enterCall', `Bearer ${authToken}`, setActionResponse);
        }
    }

    useEffect(() => {
        if (actionResponse && loading) {
            if (actionResponse.error) {
                setErrors(actionResponse.errorMessage);
            } else if (actionResponse.requestType === 'enterCall') {
                setLogEntry({...entry, id: actionResponse.data.id});
            }
            setLoading(false);
        }
    }, [actionResponse])

    return (<>
        <Paper elevation={3} sx={classes.controlPanel}>
            <Typography sx={classes.inputLabel} variant="h5" color='primary'>Enter Caller Information</Typography>
            { errors &&
                <Alert severity='error'>
                    <AlertTitle>Error!</AlertTitle>
                    {errors}
                </Alert>
            }
            <Grid2 container spacing={1} alignItems='top'>
                <Grid2
                    size={{
                        xs: 12,
                        md: 6
                    }}>
                    <FormControl
                        fullWidth
                        required
                        {...register('callerFirstName')}
                    >
                        <FormLabel shrink={true} required sx={classes.inputLabel}>First Name</FormLabel>
                        <TextField
                            id="callerFirstName"
                            name="callerFirstName"
                            variant='outlined'
                            autoComplete="off"
                            fullWidth
                            slotProps={{
                                htmlInput: {maxLength: 100, sx: classes.textbox}
                            }}
                        />
                    </FormControl>
                </Grid2>
                <Grid2
                    size={{
                        xs: 12,
                        md: 6
                    }}>
                    <FormControl
                        fullWidth
                        required
                        {...register('callerLastName')}
                    >
                        <FormLabel shrink={true} required sx={classes.inputLabel}>Last Name</FormLabel>
                        <TextField
                            id="callerLastName"
                            name="callerLastName"
                            variant='outlined'
                            autoComplete="off"
                            required
                            fullWidth
                            slotProps={{
                                htmlInput: {maxLength: 100, sx:classes.textbox}
                            }}
                        />
                    </FormControl>
                </Grid2>
                <Grid2 size={12}>
                    <Box component='div' sx={{...classes.root, display: 'flex', flexDirection: 'row-reverse', margin: '1rem 3rem'}} >
                        <Button
                            variant='contained'
                            fullWidth
                            color='primary'
                            sx={classes.squashedButton}
                            onClick={handleSubmit(saveEntry)}
                        >
                            Begin Call
                        </Button>
                    </Box>
                </Grid2>
            </Grid2>
        </Paper>
    </>);
}

export default EnterCall;
